module.exports = __webpack_public_path__ + "static/img/cucina.4733f59.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/rooms/cucina.png
// module id = mzO+
// module chunks = 1